module.exports = __webpack_public_path__ + "static/media/student-comment-next.ff144590.png";